import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import './styles/tokens.css';
import './styles/fonts.css';
import './styles/base.css';
import './styles/public.css';
import './styles/motion.css';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Application root was not found');
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);
